import { Button, Card, Descriptions, Flex, Grid, Image, Modal, Typography } from "antd";
import { Icon } from "@iconify/react";
import { useQuery } from "@tanstack/react-query";
import { Link, useParams } from "react-router";
import { registrationService } from "../../../services/registration.service";
import { userService } from "../../../services/user.service";
import { API_BASE_URL } from "../../../config/api.config";
import { useState } from "react";


export default function CanceledRegistrationDetail(){

  const { id } = useParams()

  const breakpoint = Grid.useBreakpoint()

  const [previewImage, setPrevieImage] = useState('')

  const { data: registration  } = useQuery({
    queryKey: ['canceledDataDetail', id],
    queryFn: () => registrationService.getRejectedDataById(id),
  })

  const { data: surveyor  } = useQuery({
    queryKey: ['surveyor', registration],
    queryFn: () => userService.getSurveyor(registration?.data?.ab.NAMA_AB),
  })

  console.log(surveyor)

  return (
    <>
      <Card
        title="Informasi Cancel"
        style={{ marginBottom: 20 }}
      >
        <Descriptions
          column={1}
          bordered
          size="small"
          styles={{ label: { width: 200 } }}
          items={[
            { label: 'Cancel By', children: registration?.data?.rejection?.rejectedBy?.name },
            { label: 'Alasan Cancel', children: registration?.data?.rejection?.reason },
          ]}
        />
      </Card>
      <Card
        title="Detail Data Tercancel"
      >
        <Descriptions
          column={2}
          bordered
          size="small"
          styles={{ label: { width: 200 } }}
          title="Informasi Pelanggan"
          items={[
            { span: 2, label: 'Nama Pelanggan', children: registration?.data?.nama_kustomer },
            { label: 'No Telepon', children: registration?.data?.nomor_kustomer },
            { label: 'Email', children: registration?.data?.email_kustomer },
            { label: 'Kota', children: registration?.data?.kota_kustomer },
            { label: 'Kecamatan', children: registration?.data?.kecamatan_kustomer },
            { label: 'Kelurahan', children: registration?.data?.kelurahan_kustomer },
            { label: 'Jalan', children: registration?.data?.jalan_kustomer },
            { span: 0.5, label: 'No Rumah', children: registration?.data?.no_rumah_kustomer },
            { span: 0.5, label: 'RT', children: registration?.data?.rt_kustomer },
            { span: 0.5, label: 'RW', children: registration?.data?.rw_kustomer },
          ]}
        />
        <Descriptions
          column={2}
          bordered
          style={{ marginTop: 24 }}
          size="small"
          title="Penanggung Jawab"
          styles={{ label: { width: 200 } }}
          items={[
            { span: 2, label: 'Nama Penanggung Jawab', children: registration?.data?.nama_pic },
            { label: 'No Telepon', children: registration?.data?.nomor_pic },
            { label: 'Email', children: registration?.data?.email_pic },
            { label: 'Kota', children: registration?.data?.kota_pic },
            { label: 'Kecamatan', children: registration?.data?.kecamatan_pic },
            { label: 'Kelurahan', children: registration?.data?.kelurahan_pic },
            { label: 'Jalan', children: registration?.data?.jalan_pic },
            { span: 0.5, label: 'No Rumah', children: registration?.data?.no_rumah_pic },
            { span: 0.5, label: 'RT', children: registration?.data?.rt_pic },
            { span: 0.5, label: 'RW', children: registration?.data?.rw_pic },
          ]}
        />
        <Descriptions
          column={2}
          bordered
          style={{ marginTop: 24 }}
          styles={{ label: { width: 180 } }}
          size="small"
          title="Informasi Bangunan"
          items={[
            { 
              label: 'Kebutuhan Air',
              children: registration?.data?.kebutuhan_air + 'm3'
            },
            { label: 'Ketersediaan Tangki', children: registration?.data?.ketersediaan_tangki },
            { label: 'Peruntukan Bangunan', span: 2, children: registration?.data?.peruntukan_bangunan },
            { label: 'Titik Lokasi Bangunan', span: 2, children: registration?.data?.alamat_bangunan },
          ]}
        />
        <Descriptions
          column={1}
          bordered
          style={{ marginTop: 24 }}
          styles={{ label: { width: 110 }, content: { width: '100%' } }}
          size="small"
          title="Dokumen"
          layout={breakpoint.lg ? "horizontal" : "vertical"}
          items={[
            { 
              label: 'KTP', 
              children: (
                <Flex gap={8} align="center" >
                  <Typography.Text style={{ marginRight: 'auto' }}>{registration?.data?.ktp}</Typography.Text>
                  <Flex vertical={!breakpoint.lg} gap={8} >
                    <Button 
                      icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                    >
                      <Link to={`${API_BASE_URL}/files/registration/${registration?.data?.kk}`} >
                        Unduh
                      </Link>
                    </Button>
                    <Button 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                      icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      onClick={() => setPrevieImage(`${API_BASE_URL}/files/registration/${registration?.data?.ktp}`)}
                    >
                      Lihat
                    </Button>
                  </Flex>
                  
                </Flex>
              )
            },
            { 
              label: 'KK', 
              children: (
                <Flex gap={8} align="center" >
                  <Typography.Text style={{ marginRight: 'auto' }}>{registration?.data?.kk}</Typography.Text>
                  <Flex vertical={!breakpoint.lg} gap={8} >
                    <Button 
                      icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                    >
                      Unduh
                    </Button>
                    <Button 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                      icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      onClick={() => setPrevieImage(`${API_BASE_URL}/files/registration/${registration?.data?.kk}`)}
                    >
                      Lihat
                    </Button>
                  </Flex>
                  
                </Flex>
              )
            },
            { 
              label: 'PBB', 
              children: (
                <Flex gap={8} align="center" >
                  <Typography.Text style={{ marginRight: 'auto' }}>{registration?.data?.pbb}</Typography.Text>
                  <Flex vertical={!breakpoint.lg} gap={8} >
                    <Button 
                      icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                    >
                      <Link to={`${API_BASE_URL}/files/registration/${registration?.data?.pbb}`} >
                        Unduh
                      </Link>
                    </Button>
                    <Button 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                      icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      onClick={() => setPrevieImage(`${API_BASE_URL}/files/registration/${registration?.data?.pbb}`)}
                    >
                      Lihat
                    </Button>
                  </Flex>
                </Flex>
              )
            },
            { 
              label: 'Bangunan', 
              children: (
                <Flex gap={8} align="center" >
                  <Typography.Text style={{ marginRight: 'auto' }}>{registration?.data?.bangunan}</Typography.Text>
                  <Flex vertical={!breakpoint.lg} gap={8} >
                    <Button 
                      icon={<Icon icon="solar:download-square-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                    >
                      <Link to={`${API_BASE_URL}/files/registration/${registration?.data?.bangunan}`} >
                        Unduh
                      </Link>
                    </Button>
                    <Button 
                      variant="filled" 
                      color="primary" 
                      size="small" 
                      style={{ fontSize: 12 }} 
                      icon={<Icon icon="solar:eye-bold-duotone" style={{ marginBottom: -1 }} width="18" height="18" />} 
                      onClick={() => setPrevieImage(`${API_BASE_URL}/files/registration/${registration?.data?.bangunan}`)}
                    >
                      Lihat
                    </Button>
                  </Flex>
                </Flex>
              )
            },
          ]}
        />
      </Card>
      <Modal
        open={previewImage.length > 0}
        centered
        title="Gambar"
        onCancel={()=> setPrevieImage('')}
        footer={[
          <Button variant="outlined" color="primary" key="cancel" onClick={() => setPrevieImage('')}>
            Cancel
          </Button>
        ]}
      >
        <Image src={previewImage} />
      </Modal>
    </>
  )
}